(() => {
  const root = window.Shopify?.routes?.root || '/';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let opener = null;
  let menuOpener = null;
  let cartBusy = false;
  const live = message => { const node = document.getElementById('StoreStatus'); if(node) node.textContent = message; };
  const errorMessage = error => typeof error?.description === 'string' ? error.description : typeof error?.message === 'string' ? error.message : 'Please try again.';
  async function request(path, options = {}) {
    const response = await fetch(root + path, { ...options, headers: {Accept:'application/json', ...options.headers} });
    const data = await response.json();
    if (!response.ok) throw data;
    return data;
  }
  const drawer = () => document.getElementById('CartDrawer');
  function openCart() { const node=drawer(); if(node && !node.open){opener=document.activeElement;node.showModal();document.body.style.overflow='hidden';} }
  function closeCart() { drawer()?.close(); }
  const menuDrawer = () => document.getElementById('MobileMenu');
  function openMenu() { const node=menuDrawer(); if(node && !node.open){menuOpener=document.activeElement;node.showModal();document.body.style.overflow='hidden';} }
  function closeMenu() { menuDrawer()?.close(); }
  const quickViewDialog = () => document.getElementById('QuickView');
  function closeQuickView() { quickViewDialog()?.close(); }
  const formatMoney = cents => {
    const currency = document.body.dataset.currency || 'USD';
    try { return new Intl.NumberFormat(undefined, {style:'currency', currency}).format(cents/100); }
    catch(e) { return (cents/100).toFixed(2) + ' ' + currency; }
  };
  async function openQuickView(handle, opener) {
    const dialog = quickViewDialog();
    const content = dialog?.querySelector('[data-quickview-content]');
    const titleEl = dialog?.querySelector('[data-quickview-title]');
    if(!dialog || !content) return;
    quickViewOpener = opener || document.activeElement;
    content.innerHTML = '<p class="small">Loading…</p>';
    if(titleEl) titleEl.textContent = '';
    if(!dialog.open){dialog.showModal();document.body.style.overflow='hidden';}
    try {
      const product = await request('products/' + handle + '.js');
      if(titleEl) titleEl.textContent = product.title;
      content.innerHTML = renderQuickView(product);
      bindQuickView(content, product);
    } catch(err) {
      content.innerHTML = '<p class="small">Sorry, this item couldn\'t be loaded. <a href="/products/' + handle + '">View the full page instead.</a></p>';
    }
  }
  function renderQuickView(product) {
    const variants = product.variants;
    const hasOptions = !(variants.length === 1 && variants[0].title === 'Default Title');
    const initial = variants.find(v=>v.available) || variants[0];
    const image = initial.featured_image?.src || product.featured_image || (product.images && product.images[0]) || '';
    const compareHtml = initial.compare_at_price > initial.price
      ? '<s data-qv-compare>' + formatMoney(initial.compare_at_price) + '</s>' : '<s data-qv-compare hidden></s>';
    let optionsHtml = '';
    if(hasOptions){
      const optionName = product.options && product.options[0] ? (typeof product.options[0]==='object' ? product.options[0].name : product.options[0]) : 'Options';
      optionsHtml = '<label for="QuickViewVariant">' + optionName + '</label>'
        + '<select id="QuickViewVariant" data-qv-variant-select>'
        + variants.map(v=>'<option value="'+v.id+'" data-price="'+v.price+'" data-compare="'+(v.compare_at_price||0)+'" data-available="'+v.available+'" data-image="'+(v.featured_image?.src||'')+'"'+(v.id===initial.id?' selected':'')+'>'+v.title+(v.available?'':' — Sold out')+'</option>').join('')
        + '</select>';
    }
    return ''
      + '<div class="quickview-body">'
      + '<div class="quickview-media">' + (image ? '<img src="'+image+'" alt="'+product.title.replace(/"/g,'&quot;')+'" width="600" height="600">' : '') + '</div>'
      + '<div class="quickview-info">'
      + '<p class="price-line"><span data-qv-price>'+formatMoney(initial.price)+'</span> '+compareHtml+'</p>'
      + optionsHtml
      + '<label for="QuickViewQty">Quantity</label><input id="QuickViewQty" type="number" min="1" value="1" data-qv-qty>'
      + '<p class="form-error" data-qv-error role="alert"></p>'
      + '<button type="button" class="button full" data-qv-add data-original="Add to bag" data-variant-id="'+initial.id+'"'+(initial.available?'':' disabled')+'>'+(initial.available?'Add to bag':'Sold out')+'</button>'
      + '<a class="text-link" href="'+product.url+'">View full details →</a>'
      + '</div></div>';
  }
  function bindQuickView(content, product) {
    const select = content.querySelector('[data-qv-variant-select]');
    const addBtn = content.querySelector('[data-qv-add]');
    const img = content.querySelector('.quickview-media img');
    function syncFromOption(option){
      content.querySelector('[data-qv-price]').textContent = formatMoney(Number(option.dataset.price));
      const compareEl = content.querySelector('[data-qv-compare]');
      const compare = Number(option.dataset.compare);
      if(compare > Number(option.dataset.price)){compareEl.hidden=false;compareEl.textContent=formatMoney(compare);}
      else compareEl.hidden = true;
      const available = option.dataset.available === 'true';
      addBtn.disabled = !available;
      addBtn.textContent = available ? addBtn.dataset.original : 'Sold out';
      addBtn.dataset.variantId = option.value;
      if(option.dataset.image && img) img.src = option.dataset.image;
    }
    select?.addEventListener('change', () => syncFromOption(select.selectedOptions[0]));
    addBtn?.addEventListener('click', async () => {
      if(addBtn.disabled || cartBusy) return;
      cartBusy = true; addBtn.disabled = true;
      const error = content.querySelector('[data-qv-error]'); if(error) error.textContent = '';
      const qty = Math.max(1, Number(content.querySelector('[data-qv-qty]')?.value) || 1);
      try {
        await request('cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items:[{id:Number(addBtn.dataset.variantId), quantity: qty}]})});
        await refreshCart();
        closeQuickView();
        openCart();
      } catch(err) { if(error) error.textContent = errorMessage(err); }
      finally { cartBusy = false; addBtn.disabled = false; }
    });
  }
  let quickViewOpener = null;
  async function refreshCart() {
    const cart = await request('cart.js');
    document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=String(cart.item_count));
    const response = await fetch(root + '?sections=cart-drawer', {headers:{Accept:'application/json'}});
    if(!response.ok) throw new Error('Your bag was updated. Open the full bag to review it.');
    const sections = await response.json();
    const doc = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
    const content = doc.querySelector('#DrawerContent');
    if(!content) throw new Error('Your bag was updated. Open the full bag to review it.');
    const current = document.getElementById('DrawerContent');
    const active = document.activeElement;
    const focused = current?.contains(active);
    const focusedKey = active?.dataset?.cartChange;
    const focusedLabel = active?.getAttribute('aria-label');
    if(current) current.innerHTML=content.innerHTML;
    if(focused){
      const replacement = [...(current?.querySelectorAll('[data-cart-change]') || [])].find(el=>el.dataset.cartChange===focusedKey && el.getAttribute('aria-label')===focusedLabel);
      (replacement || drawer()?.querySelector('[data-close-cart]'))?.focus();
    }
    live('Bag updated. ' + cart.item_count + ' items.');
    document.dispatchEvent(new CustomEvent('mp:cart:updated', { detail: { cart } }));
  }
  async function addProduct(form, buyNow, submitter) {
    const message=form.querySelector('[data-form-error]');
    if(message) message.textContent='';
    const bundleField=form.querySelector('[data-bundle-items]');
    const buttons=[...form.querySelectorAll('button')];buttons.forEach(b=>b.disabled=true);
    try {
      const options=bundleField&&bundleField.value
        ? {method:'POST',headers:{'Content-Type':'application/json'},body:bundleField.value}
        : {method:'POST',body:new FormData(form)};
      await request('cart/add.js',options);
      if(buyNow){await window.MPHalloween?.syncGift?.();window.location.assign(root+'checkout');return;}
      await refreshCart();openCart();
    } catch(error) {
      if(message) message.textContent=errorMessage(error);
    } finally {
      if(bundleField){
        buttons.forEach(b=>b.disabled=false);
        form.dispatchEvent(new CustomEvent('bundle:submitted',{bubbles:true}));
      }else{
        const unavailable=form.querySelector('[data-variant-select]')?.selectedOptions[0]?.dataset.available==='false';
        buttons.forEach(b=>b.disabled=unavailable);
      }
      if(submitter) submitter.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('submit', event=>{
    const form=event.target.closest('[data-product-form]');
    if(!form) return;
    // Accelerated Shopify payment buttons retain their native behaviour.
    if(event.submitter && !event.submitter.matches('[data-add-button],[data-buy-now]')) return;
    event.preventDefault();event.submitter?.setAttribute('aria-busy','true');
    addProduct(form,Boolean(event.submitter?.matches('[data-buy-now]')),event.submitter);
  });
  document.addEventListener('change',event=>{
    const select=event.target.closest('[data-variant-select]');if(!select)return;
    const option=select.selectedOptions[0], scope=select.closest('[data-product-root]');
    scope.querySelectorAll('[data-product-price]').forEach(n=>n.textContent=option.dataset.price);
    scope.querySelectorAll('[data-product-compare]').forEach(n=>{n.textContent=option.dataset.compare;n.hidden=option.dataset.sale!=='true';});
    scope.querySelectorAll('[data-product-savings]').forEach(n=>{n.textContent=option.dataset.savingsText||'';n.hidden=option.dataset.sale!=='true'||!option.dataset.savingsText;});
    scope.querySelectorAll('[data-add-button],[data-buy-now]').forEach(n=>{
      if(!n.dataset.original)n.dataset.original=n.textContent;
      n.disabled=option.dataset.available!=='true';
      n.textContent=n.disabled?'Sold out':n.dataset.original;
    });
    const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);
    if(option.dataset.media){
      const media=scope.querySelector('[id$="-'+option.dataset.media+'"]');
      if(media){const gallery=media.parentElement;gallery.prepend(media);gallery.scrollTo({left:0,behavior:'auto'});live('Product image updated for '+option.textContent.trim());}
    }
  });
  document.addEventListener('click',async event=>{
    const open=event.target.closest('[data-open-cart]');
    if(open && drawer()?.showModal){event.preventDefault();openCart();return;}
    if(event.target.closest('[data-close-cart]')){closeCart();return;}
    if(event.target.closest('[data-open-menu]')){openMenu();return;}
    if(event.target.closest('[data-close-menu]')){closeMenu();return;}
    const qv=event.target.closest('[data-quick-view]');
    if(qv){event.preventDefault();openQuickView(qv.dataset.quickView,qv);return;}
    if(event.target.closest('[data-close-quickview]')){closeQuickView();return;}
    const swatchBtn=event.target.closest('[data-swatch-variant]');
    if(swatchBtn){
      if(swatchBtn.disabled)return;
      const group=swatchBtn.closest('[data-color-swatches]');
      const select=document.getElementById(group.dataset.selectTarget);
      if(select){select.value=swatchBtn.dataset.swatchVariant;select.dispatchEvent(new Event('change',{bubbles:true}));}
      group.querySelectorAll('[data-swatch-variant]').forEach(b=>b.setAttribute('aria-checked',b===swatchBtn?'true':'false'));
      return;
    }
    const qtyBtn=event.target.closest('[data-qty-decrease],[data-qty-increase]');
    if(qtyBtn){
      const input=qtyBtn.closest('[data-qty-stepper]')?.querySelector('[data-qty-input]');
      if(input){
        const min=Number(input.min)||1;
        let val=Number(input.value)||min;
        val=qtyBtn.hasAttribute('data-qty-decrease')?Math.max(min,val-1):val+1;
        input.value=val;
      }
      return;
    }
    const change=event.target.closest('[data-cart-change]'),add=event.target.closest('[data-quick-add]');
    if(change||add){
      if(cartBusy)return;cartBusy=true;const control=change||add;control.disabled=true;
      const error=document.getElementById('CartError');if(error)error.textContent='';
      try{
        if(change)await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:change.dataset.cartChange,quantity:Number(change.dataset.quantity)})});
        else await request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(add.dataset.quickAdd),quantity:1}]})});
        await refreshCart();
        if(add)openCart();
      }catch(err){if(error)error.textContent=errorMessage(err);}
      finally{cartBusy=false;control.disabled=false;}
    }
    const reelButton=event.target.closest('[data-reel-play],[data-reel-sound]');
    if(reelButton){
      const video=reelButton.closest('.reel-card').querySelector('video');if(!video)return;
      if(reelButton.hasAttribute('data-reel-sound')){video.muted=!video.muted;reelButton.textContent=video.muted?'Sound off':'Sound on';reelButton.setAttribute('aria-label',video.muted?'Unmute reel':'Mute reel');}
      else if(video.paused){video.dataset.manualPaused='false';video.play().catch(()=>{});}
      else{video.dataset.manualPaused='true';video.pause();}
    }
  });
  let revealObserver, reelObserver;
  const carouselStates=new Map(), highlights=new Set();
  let motionFrame=0;
  const motionOn=()=>document.body.dataset.motion==='true'&&!reduced.matches;
  function pauseAutomatically(video){if(!video.paused){video.dataset.autoPausing='true';video.pause();}}
  function syncVideos(state){
    state.cards.forEach((card,index)=>{
      const video=card.querySelector('video');if(!video)return;
      if(index===state.active && state.visible && !document.hidden && !reduced.matches && state.section.dataset.autoplay!=='false' && video.dataset.manualPaused!=='true'){
        if(video.paused) video.play().catch(()=>{});
      }else if(index!==state.active||!state.visible||document.hidden)pauseAutomatically(video);
    });
  }
  function paintCarousel(state){
    const {track,cards,section}=state;
    const centre=track.scrollLeft+track.clientWidth/2;
    let nearest=0,distance=Infinity;
    cards.forEach((card,index)=>{
      const delta=(card.offsetLeft+card.offsetWidth/2-centre)/(card.offsetWidth+26);
      if(Math.abs(delta)<distance){distance=Math.abs(delta);nearest=index;}
      const bounded=Math.max(-2.4,Math.min(2.4,delta)), enabled=motionOn()&&section.dataset.wheel!=='false';
      card.style.setProperty('--wheel-angle',(enabled?bounded*8:0)+'deg');
      card.style.setProperty('--wheel-y',(enabled?Math.abs(bounded)*Math.abs(bounded)*12:0)+'px');
      card.style.setProperty('--wheel-scale',String(enabled?Math.max(.80,1-Math.abs(bounded)*.075):1));
      card.style.setProperty('--wheel-opacity',String(enabled?Math.max(.62,1-Math.abs(bounded)*.13):1));
    });
    if(state.active!==nearest){
      state.active=nearest;
      cards.forEach((c,i)=>c.classList.toggle('is-active',i===nearest));
      section.querySelectorAll('[data-reel-go]').forEach((b,i)=>b.setAttribute('aria-current',String(i===nearest)));
      const status=section.querySelector('[data-reel-status]');if(status)status.textContent=cards.length?(nearest+1)+' / '+cards.length:'';
      section.querySelector('[data-reel-prev]').disabled=nearest===0;
      section.querySelector('[data-reel-next]').disabled=nearest>=cards.length-1;
      syncVideos(state);
    }
  }
  function moveCarousel(state,index){
    const card=state.cards[Math.max(0,Math.min(state.cards.length-1,index))];if(!card)return;
    state.track.scrollTo({left:card.offsetLeft+card.offsetWidth/2-state.track.clientWidth/2,behavior:motionOn()?'smooth':'auto'});
  }
  function updateMotion(){
    motionFrame=0;
    highlights.forEach(el=>{
      if(!el.isConnected){highlights.delete(el);return;}
      const rect=el.getBoundingClientRect();
      const progress=motionOn()?Math.max(0,Math.min(1,(innerHeight*.90-rect.top)/(innerHeight*.40))):1;
      el.style.setProperty('--highlight-progress',(progress*100).toFixed(1)+'%');
    });
    lineSplitHighlights.forEach(el=>{
      if(!el.isConnected){lineSplitHighlights.delete(el);return;}
      const total=Number(el.dataset.hlCount||0);
      if(!total)return;
      const rect=el.getBoundingClientRect();
      const overall=motionOn()?Math.max(0,Math.min(1,(innerHeight*.85-rect.top)/(innerHeight*.5))):1;
      const lit=overall*total;
      el.querySelectorAll('.hl-char').forEach(ch=>{
        const i=Number(ch.style.getPropertyValue('--hl-i'));
        const fill=Math.max(0,Math.min(1,lit-i));
        ch.style.setProperty('--hl-fill',fill.toFixed(3));
      });
    });
    carouselStates.forEach(state=>paintCarousel(state));
  }
  function scheduleMotion(){if(!motionFrame)motionFrame=requestAnimationFrame(updateMotion);}
  const lineSplitHighlights=new Set();
  function splitHighlightChars(el){
    if(el.dataset.hlSplit)return;
    const text=el.textContent;
    if(!text.trim())return;
    el.dataset.hlSplit='true';
    el.classList.add('hl-split');
    el.textContent='';
    let idx=0;
    [...text].forEach(ch=>{
      if(/\s/.test(ch)){el.appendChild(document.createTextNode(ch));return;}
      const span=document.createElement('span');
      span.className='hl-char';
      span.textContent=ch;
      span.style.setProperty('--hl-i',idx++);
      el.appendChild(span);
    });
    el.dataset.hlCount=idx;
  }
  const galleryStates=new WeakSet();
  function initGallery(root){
    if(galleryStates.has(root))return;
    const track=root.querySelector('[data-gallery-track]');
    const slides=[...root.querySelectorAll('[data-gallery-slide]')];
    if(!track||slides.length<2)return;
    galleryStates.add(root);
    const thumbs=[...root.querySelectorAll('[data-gallery-thumb]')];
    const prevBtn=root.querySelector('[data-gallery-prev]');
    const nextBtn=root.querySelector('[data-gallery-next]');
    let active=0;
    function setActive(i){
      active=Math.max(0,Math.min(slides.length-1,i));
      thumbs.forEach((t,idx)=>t.setAttribute('aria-current',String(idx===active)));
      if(prevBtn)prevBtn.disabled=active===0;
      if(nextBtn)nextBtn.disabled=active===slides.length-1;
    }
    function goTo(i){
      const slide=slides[Math.max(0,Math.min(slides.length-1,i))];
      if(!slide)return;
      track.scrollTo({left:slide.offsetLeft,behavior:motionOn()?'smooth':'auto'});
    }
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>{goTo(i);setActive(i);}));
    prevBtn?.addEventListener('click',()=>{goTo(active-1);setActive(active-1);});
    nextBtn?.addEventListener('click',()=>{goTo(active+1);setActive(active+1);});
    let scrollTimer=0;
    track.addEventListener('scroll',()=>{
      clearTimeout(scrollTimer);
      scrollTimer=setTimeout(()=>{
        let nearest=0,nearestDist=Infinity;
        slides.forEach((s,i)=>{const d=Math.abs(s.offsetLeft-track.scrollLeft);if(d<nearestDist){nearestDist=d;nearest=i;}});
        setActive(nearest);
      },100);
    },{passive:true});
    setActive(0);
  }
  function initCarousel(section){
    if(carouselStates.has(section))return;
    const track=section.querySelector('.reel-track'),cards=[...section.querySelectorAll('.reel-card')];
    if(!track||!cards.length)return;
    const state={section,track,cards,active:-1,visible:false};
    carouselStates.set(section,state);
    track.addEventListener('scroll',scheduleMotion,{passive:true});
    track.addEventListener('keydown',event=>{
      if(event.target!==track)return;
      if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();moveCarousel(state,state.active+(event.key==='ArrowRight'?1:-1));}
      if(event.key==='Home'||event.key==='End'){event.preventDefault();moveCarousel(state,event.key==='Home'?0:cards.length-1);}
    });
    section.querySelector('[data-reel-prev]')?.addEventListener('click',()=>moveCarousel(state,state.active-1));
    section.querySelector('[data-reel-next]')?.addEventListener('click',()=>moveCarousel(state,state.active+1));
    section.querySelectorAll('[data-reel-go]').forEach(button=>button.addEventListener('click',()=>moveCarousel(state,Number(button.dataset.reelGo))));
    let gestureBusy=false,gestureTimer=null;
    const stage=section.querySelector('.reel-stage')||section;
    function reelAtLast(){return state.active>=cards.length-1;}
    function reelAtFirst(){return state.active<=0;}
    function reelInView(){
      const r=stage.getBoundingClientRect();
      return r.top<innerHeight*0.65&&r.bottom>innerHeight*0.35;
    }
    function triggerReelStep(goingNext){
      clearTimeout(gestureTimer);
      gestureTimer=setTimeout(()=>{gestureBusy=false;},420);
      if(gestureBusy)return;
      gestureBusy=true;
      const next=Math.max(0,Math.min(cards.length-1,state.active+(goingNext?1:-1)));
      state.active=next;
      moveCarousel(state,next);
    }
    section.addEventListener('wheel',event=>{
      if(!motionOn()||!reelInView()||Math.abs(event.deltaY)<=Math.abs(event.deltaX))return;
      const goingNext=event.deltaY>0&&!reelAtLast(), goingPrev=event.deltaY<0&&!reelAtFirst();
      if(!goingNext&&!goingPrev)return;
      event.preventDefault();
      triggerReelStep(goingNext);
    },{passive:false});
    let touchStartY=null,touchStartX=null,touchLocked=false;
    section.addEventListener('touchstart',event=>{
      if(!motionOn()||!reelInView())return;
      touchStartY=event.touches[0].clientY;
      touchStartX=event.touches[0].clientX;
      touchLocked=false;
    },{passive:true});
    section.addEventListener('touchmove',event=>{
      if(touchStartY===null)return;
      const deltaY=touchStartY-event.touches[0].clientY;
      const deltaX=touchStartX-event.touches[0].clientX;
      if(Math.abs(deltaY)<=Math.abs(deltaX))return;
      const goingNext=deltaY>0&&!reelAtLast(), goingPrev=deltaY<0&&!reelAtFirst();
      if(!goingNext&&!goingPrev)return;
      if(Math.abs(deltaY)<12)return;
      event.preventDefault();
      if(!touchLocked&&Math.abs(deltaY)>36){
        touchLocked=true;
        triggerReelStep(goingNext);
      }
    },{passive:false});
    section.addEventListener('touchend',()=>{touchStartY=null;touchStartX=null;touchLocked=false;});
    cards.forEach(card=>{
      const video=card.querySelector('video');if(!video)return;
      const button=card.querySelector('[data-reel-play]');
      const sync=()=>{if(button){button.textContent=video.paused?'Play':'Pause';button.setAttribute('aria-label',video.paused?'Play reel':'Pause reel');}};
      video.addEventListener('play',()=>{
        video.dataset.manualPaused='false';
        cards.forEach(other=>{const sibling=other.querySelector('video');if(sibling&&sibling!==video)pauseAutomatically(sibling);});
        const index=cards.indexOf(card);if(index!==state.active)moveCarousel(state,index);
        sync();
      });
      video.addEventListener('pause',()=>{if(video.dataset.autoPausing==='true')delete video.dataset.autoPausing;else video.dataset.manualPaused='true';sync();});
      video.addEventListener('volumechange',()=>{const sound=card.querySelector('[data-reel-sound]');if(sound){sound.textContent=video.muted?'Sound off':'Sound on';sound.setAttribute('aria-label',video.muted?'Unmute reel':'Mute reel');}});
    });
    if('IntersectionObserver' in window){
      reelObserver ||= new IntersectionObserver(entries=>entries.forEach(entry=>{
        const state=carouselStates.get(entry.target);if(state){state.visible=entry.isIntersecting;syncVideos(state);}
      }),{threshold:.25});
      reelObserver.observe(section);
    }
    requestAnimationFrame(()=>{const card=cards[Math.floor(cards.length/2)];track.scrollLeft=card.offsetLeft+card.offsetWidth/2-track.clientWidth/2;paintCarousel(state);});
  }
  function initStickyAtc(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    const realAdd = form.querySelector('[data-add-button]');
    const priceSource = form.querySelector('[data-bundle-total-price]') || document.querySelector('[data-product-price]');
    const stickyPrice = bar.querySelector('[data-sticky-price]');
    const stickyBtn = bar.querySelector('[data-sticky-add]');
    function sync() {
      if (stickyPrice && priceSource) stickyPrice.textContent = priceSource.textContent;
      if (stickyBtn && realAdd) stickyBtn.classList.toggle('is-disabled', realAdd.disabled);
    }
    sync();
    if (priceSource) new MutationObserver(sync).observe(priceSource, { characterData: true, subtree: true, childList: true });
    if (realAdd) {
      let wasReady = !realAdd.disabled;
      new MutationObserver(() => {
        sync();
        const ready = !realAdd.disabled;
        if (ready && !wasReady && stickyBtn) {
          stickyBtn.classList.remove('is-shaking');
          void stickyBtn.offsetWidth;
          stickyBtn.classList.add('is-shaking');
          setTimeout(() => stickyBtn.classList.remove('is-shaking'), 500);
        }
        wasReady = ready;
      }).observe(realAdd, { attributes: true, attributeFilter: ['disabled'] });
      stickyBtn?.addEventListener('click', () => {
        if (realAdd.disabled) {
          const colors = document.querySelector('[data-bundle-colors]');
          const tiers = document.querySelector('.mp-bb-tiers');
          const message = document.querySelector('[data-bundle-message]');
          const target = colors && !colors.hidden ? colors : tiers;
          if (message) message.textContent = colors && !colors.hidden
            ? (message.textContent || 'Choose a color for each frame')
            : 'Choose a bundle to continue';
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            target.classList.remove('mp-bb-attention');
            void target.offsetWidth;
            target.classList.add('mp-bb-attention');
            setTimeout(() => target.classList.remove('mp-bb-attention'), 1200);
          }
          return;
        }
        realAdd.click();
      });
    }
    const target = form.querySelector('[data-bundle-cta]') || realAdd;
    if (target && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(target);
    }
  }
  const recommendationStates=new WeakSet();
  function initRecommendations(el){
    if(recommendationStates.has(el))return;
    recommendationStates.add(el);
    const url=el.dataset.url;
    if(!url)return;
    fetch(url).then(res=>res.text()).then(html=>{
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.getElementById(el.id);
      if(fresh&&fresh.children.length){
        el.innerHTML=fresh.innerHTML;
        init(el);
      }else{
        const fallback=el.parentElement?.querySelector('[data-recommendations-fallback]');
        if(fallback){
          fallback.hidden=false;
          el.remove();
          init(fallback);
        }else{
          el.closest('.section-pad')?.remove();
        }
      }
    }).catch(()=>{
      const fallback=el.parentElement?.querySelector('[data-recommendations-fallback]');
      if(fallback){fallback.hidden=false;el.remove();init(fallback);}
    });
  }
  function initRotatingReviews(root){
    if(root.dataset.rrInit)return;
    root.dataset.rrInit='true';
    const items=[...root.querySelectorAll('[data-rotating-review]')];
    const dots=[...root.querySelectorAll('[data-rotating-dot]')];
    if(items.length<=1)return;
    const intervalMs=Math.max(3,Number(root.dataset.interval)||6)*1000;
    let index=items.findIndex(el=>el.classList.contains('is-active'));
    if(index<0)index=0;
    let timer=null;
    function show(next){
      items[index]?.classList.remove('is-active');
      dots[index]?.classList.remove('is-active');
      index=next;
      items[index]?.classList.add('is-active');
      dots[index]?.classList.add('is-active');
    }
    function step(){show((index+1)%items.length);}
    function stop(){if(timer)clearInterval(timer);timer=null;}
    function start(){if(reduced.matches)return;stop();timer=setInterval(step,intervalMs);}
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);start();}));
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',start);
    root.addEventListener('focusin',stop);
    root.addEventListener('focusout',start);
    reduced.addEventListener('change',()=>{if(reduced.matches)stop();else start();});
    start();
  }
  function initFloatingVideo(root){
    if(root.dataset.fvInit)return;
    root.dataset.fvInit='true';
    const openBtn=root.querySelector('[data-floating-video-open]');
    const modal=root.querySelector('[data-floating-video-modal]');
    const closeEls=[...root.querySelectorAll('[data-floating-video-close]')];
    const previewVideo=root.querySelector('.floating-video-preview');
    const modalVideo=root.querySelector('.floating-video-player');
    if(reduced.matches&&previewVideo){previewVideo.pause();previewVideo.removeAttribute('autoplay');}
    let lastFocus=null;
    function onKeydown(e){if(e.key==='Escape')close();}
    function open(){
      lastFocus=document.activeElement;
      modal.hidden=false;
      requestAnimationFrame(()=>modal.classList.add('is-open'));
      previewVideo?.pause();
      if(modalVideo){modalVideo.currentTime=0;modalVideo.play().catch(()=>{});}
      document.addEventListener('keydown',onKeydown);
      closeEls[0]?.focus();
    }
    function close(){
      modal.classList.remove('is-open');
      modalVideo?.pause();
      setTimeout(()=>{modal.hidden=true;},reduced.matches?0:300);
      if(!reduced.matches)previewVideo?.play().catch(()=>{});
      document.removeEventListener('keydown',onKeydown);
      lastFocus?.focus();
    }
    openBtn?.addEventListener('click',open);
    closeEls.forEach(el=>el.addEventListener('click',close));
  }
  function init(scope=document) {
    if(motionOn() && 'IntersectionObserver' in window){
      document.documentElement.classList.add('motion-ready');
      revealObserver ||= new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target);}
      }),{threshold:0,rootMargin:'0px 0px -24px 0px'});
      scope.querySelectorAll('.steps-grid,.review-grid,.bundle-grid,.product-grid').forEach(group=>{
        [...group.children].forEach((card,i)=>{card.classList.add('reveal');card.style.setProperty('--reveal-delay',Math.min(i%4,3)*90+'ms');});
      });
      scope.querySelectorAll('.reveal').forEach(el=>revealObserver.observe(el));
    }else scope.querySelectorAll('.reveal').forEach(el=>el.classList.add('is-visible'));
    scope.querySelectorAll('.highlight').forEach(el=>highlights.add(el));
    scope.querySelectorAll('.highlight.hl-lines').forEach(el=>{
      splitHighlightChars(el);
      lineSplitHighlights.add(el);
    });
    scope.querySelectorAll('.reels-section').forEach(initCarousel);
    scope.querySelectorAll('[data-product-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-product-recommendations]').forEach(initRecommendations);
    scope.querySelectorAll('[data-rotating-reviews]').forEach(initRotatingReviews);
    scope.querySelectorAll('[data-floating-video]').forEach(initFloatingVideo);
    scope.querySelectorAll('.footer-accordion').forEach(el=>{
      if(el.dataset.footerReady)return;
      el.dataset.footerReady='true';
      if(window.matchMedia('(max-width:1000px)').matches)el.removeAttribute('open');
    });
    scope.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
    const dialog=drawer();
    if(dialog&&!dialog.dataset.ready){dialog.dataset.ready='true';
      dialog.addEventListener('close',()=>{document.body.style.overflow='';opener?.focus?.();});
      dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right)closeCart();}});
    }
    const menuDialog=menuDrawer();
    if(menuDialog&&!menuDialog.dataset.ready){menuDialog.dataset.ready='true';
      menuDialog.addEventListener('close',()=>{document.body.style.overflow='';menuOpener?.focus?.();});
      menuDialog.addEventListener('click',event=>{if(event.target===menuDialog)closeMenu();});
    }
    const qvDialog=quickViewDialog();
    if(qvDialog&&!qvDialog.dataset.ready){qvDialog.dataset.ready='true';
      qvDialog.addEventListener('close',()=>{document.body.style.overflow='';quickViewOpener?.focus?.();});
      qvDialog.addEventListener('click',event=>{if(event.target===qvDialog)closeQuickView();});
    }
    scheduleMotion();
  }
  let cardTouchTimer=null;
  document.addEventListener('touchstart',event=>{
    const media=event.target.closest('.card-media');
    document.querySelectorAll('.card-media.is-touched').forEach(el=>{if(el!==media)el.classList.remove('is-touched');});
    if(media)media.classList.add('is-touched');
  },{passive:true});
  document.addEventListener('touchend',()=>{
    clearTimeout(cardTouchTimer);
    cardTouchTimer=setTimeout(()=>document.querySelectorAll('.card-media.is-touched').forEach(el=>el.classList.remove('is-touched')),1000);
  },{passive:true});
  window.addEventListener('scroll',scheduleMotion,{passive:true});
  window.addEventListener('resize',scheduleMotion,{passive:true});
  document.addEventListener('visibilitychange',()=>carouselStates.forEach(syncVideos));
  reduced.addEventListener('change',()=>{if(reduced.matches){document.documentElement.classList.remove('motion-ready');document.querySelectorAll('video.reel-video').forEach(pauseAutomatically);}init();});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.reel-card');if(card){const state=carouselStates.get(card.closest('.reels-section'));if(state)moveCarousel(state,Number(card.dataset.reelIndex));}});
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll('.reveal').forEach(el=>revealObserver?.unobserve(el));
    event.target.querySelectorAll('video').forEach(el=>el.pause());
    event.target.querySelectorAll('.reels-section').forEach(el=>{reelObserver?.unobserve(el);carouselStates.delete(el);});
  });
  init();
})();
